// axiosInstance.js
import axios from 'axios'
const http = axios.create({
  timeout: 10000, // 请求超时时间
  withCredentials: true,
})

// 请求拦截器
http.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return Promise.reject(error)
  },
)

// 响应拦截器
http.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  },
)

// 导出 Axios 实例
export default http
